import { createRouter, createWebHistory } from 'vue-router';

/* Layout */
import Layout from '@/layout';

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/third-charge/scan',
    component: () => import('@/views/public/thirdCharge/scan.vue'),
    hidden: true,
    meta: {
      publicRoute: true,
      title: '扫码充电'
    }
  },
  {
    path: '/third-charge/charging',
    component: () => import('@/views/public/thirdCharge/charging.vue'),
    hidden: true,
    meta: {
      publicRoute: true,
      title: '充电中'
    }
  },
  {
    path: '/third-charge/result',
    component: () => import('@/views/public/thirdCharge/result.vue'),
    hidden: true,
    meta: {
      publicRoute: true,
      title: '充电结果'
    }
  },
  {
    path: '/redirect/:path(.*)',
    component: () => import('@/views/redirect.vue'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/statisticsList',
    meta: {
      title: '主页',
      icon: 'dashboard',
      keepAlive: true
    },

    children: [
      {
        path: '/statisticsList',
        name: 'statisticsList',
        component: () => import('@/views/statistics/userStatistics'),
        meta: {
          title: '数据统计',
          keepAlive: true
        }
      }
      // {
      //     path: '/dayRecharge',
      //     name: 'dayRecharge',
      //     component: () => import('@/views/statistics/dayRecharge'),
      //     hidden: true,
      //     meta: {
      //         title: '充值记录',
      //         activeMenu: '/statistics/statisticsList'
      //     }
      // }
    ]
  }
];

export const asyncRouterMap = [
  // ... (same as before, unchanged)
  {
    path: '/home',
    component: Layout,
    redirect: '/home',
    meta: { title: '地图概览', noCache: true, keepAlive: true },
    children: [{ path: '/home', name: 'home', component: () => import('@/views/home'), meta: { title: '地图概览', keepAlive: true } }]
  },
  {
    path: '/total', name: 'total', component: Layout,
    meta: { title: '经营管理', icon: 'tongji', noCache: true, keepAlive: true },
    children: [{ path: '/totalList', name: 'totalList', component: () => import('@/views/total/totalList'), meta: { title: '经营管理', icon: 'dingdan', keepAlive: true } }]
  },
  {
    path: '/plot', name: 'plot', component: Layout,
    meta: { title: '站点管理', icon: 'shebei', keepAlive: true },
    children: [{ path: '/plotList', name: 'plotList', component: () => import('@/views/device/plotList'), meta: { title: '站点管理', keepAlive: true } }]
  },
  {
    path: '/chargeBox', name: 'chargeBox', component: Layout,
    meta: { title: '补电车管理', icon: 'shebei', keepAlive: true },
    children: [
      { path: '/chargeBoxInfo', name: 'chargeBoxInfo', component: () => import('@/views/chargeBox/chargeBoxInfo'), meta: { title: '补电车基本信息', keepAlive: true } },
      { path: '/chargeBoxOperation', name: 'chargeBoxOperation', component: () => import('@/views/chargeBox/chargeBoxOperation'), meta: { title: '补电车运营信息', keepAlive: true } },
      { path: '/chargeBoxAdd', name: 'chargeBoxAdd', component: () => import('@/views/chargeBox/chargeBoxAdd'), meta: { title: '新增补电车', keepAlive: false }, hidden: true },
      { path: '/chargeBoxDetail', name: 'chargeBoxDetail', component: () => import('@/views/chargeBox/chargeBoxDetail'), meta: { title: '补电车详情', keepAlive: false }, hidden: true }
    ]
  },
  {
    path: '/device', component: Layout, name: 'device', redirect: 'noRedirect',
    meta: { title: '设备管理', icon: 'shebei', keepAlive: true },
    children: [
      { path: '/deviceList', name: 'deviceList', component: () => import('@/views/device/deviceList'), meta: { title: '充电桩管理', keepAlive: true } },
      { path: '/simCard', name: 'simCard', component: () => import('@/views/simCard/index'), meta: { title: 'SIM卡管理', icon: 'sim', keepAlive: true } },
      { path: '/portList', name: 'portList', component: () => import('@/views/device/portList'), meta: { title: '枪口管理', activeMenu: '/portList', keepAlive: false } },
      { path: '/deviceManufacturerList', name: 'deviceManufacturerList', component: () => import('@/views/device/deviceManufacturerList'), meta: { title: '设备厂商信息', activeMenu: '/deviceManufacturerList', keepAlive: true } },
      { path: '/devicePurchaseList', name: 'devicePurchaseList', component: () => import('@/views/device/devicePurchaseList'), meta: { title: '设备采购记录', activeMenu: '/devicePurchaseList', keepAlive: true } }
    ]
  },
  {
    path: '/deviceLog', component: Layout, name: 'deviceLog', redirect: 'noRedirect',
    meta: { title: '日志管理', icon: 'shebei', keepAlive: true },
    children: [
      { path: '/deviceLogOther', name: 'deviceLogOther', component: () => import('@/views/device/deviceLogOther.vue'), meta: { title: '交互日志', keepAlive: true } },
      { path: '/deviceLogCharging', name: 'deviceLogCharging', component: () => import('@/views/device/deviceLogCharging.vue'), meta: { title: '充电日志', keepAlive: true } }
    ]
  },
  {
    path: '/chargeOrderList', component: Layout, name: 'chargeOrderList', redirect: 'noRedirect',
    meta: { title: '订单管理', icon: 'dingdan', keepAlive: true },
    children: [
      { path: '/orderListReal', name: 'orderListReal', component: () => import('@/views/chargingOrder/orderListReal.vue'), meta: { title: '实时订单', activeMenu: '/orderListReal', keepAlive: true } },
      { path: '/orderListHistory', name: 'orderListHistory', component: () => import('@/views/chargingOrder/orderListHistory.vue'), meta: { title: '历史订单', activeMenu: '/orderListHistory', keepAlive: true } },
      { path: '/orderListAbnormal', name: 'orderListAbnormal', component: () => import('@/views/chargingOrder/orderListAbnormal.vue'), meta: { title: '异常订单', activeMenu: '/orderListAbnormal', keepAlive: true } },
      { path: '/orderListRefund', name: 'orderListRefund', component: () => import('@/views/chargingOrder/orderListRefund.vue'), meta: { title: '退款订单', activeMenu: '/orderListRefund', keepAlive: true } },
      { path: '/orderListAll', name: 'orderListAll', component: () => import('@/views/chargingOrder/orderListAll.vue'), meta: { title: '全部订单', activeMenu: '/orderListAll', keepAlive: true } },
      { path: '/orderListOccupancy', name: 'orderListOccupancy', component: () => import('@/views/chargingOrder/orderListReOccupancy.vue'), meta: { title: '占位订单', activeMenu: '/orderListOccupancy', keepAlive: true } },
      { path: '/orderListAppointment', name: 'orderListAppointment', component: () => import('@/views/chargingOrder/orderListAppointment.vue'), meta: { title: '预约订单', activeMenu: '/orderListAppointment', keepAlive: true } },
      { path: '/orderListDetailAll', name: 'orderListDetailAll', component: () => import('@/views/chargingOrder/orderListDetail.vue'), hidden: true, meta: { title: '全部订单详情', activeMenu: '/orderListAll', keepAlive: false } },
      { path: '/orderListDetailReal', name: 'orderListDetailReal', component: () => import('@/views/chargingOrder/orderListDetail.vue'), hidden: true, meta: { title: '实时订单详情', activeMenu: '/orderListReal', keepAlive: false } },
      { path: '/orderListDetailHistory', name: 'orderListDetailHistory', component: () => import('@/views/chargingOrder/orderListDetail.vue'), hidden: true, meta: { title: '历史订单详情', activeMenu: '/orderListHistory', keepAlive: false } },
      { path: '/orderListDetailAbnormal', name: 'orderListDetailAbnormal', component: () => import('@/views/chargingOrder/orderListDetail.vue'), hidden: true, meta: { title: '异常订单详情', activeMenu: '/orderListAbnormal', keepAlive: false } },
      { path: '/orderListDetailRefund', name: 'orderListDetailRefund', component: () => import('@/views/chargingOrder/orderListDetail.vue'), hidden: true, meta: { title: '退款订单详情', activeMenu: '/orderListRefund', keepAlive: false } },
      { path: '/orderListDetailOccupancy', name: 'orderListDetailOccupancy', component: () => import('@/views/chargingOrder/orderListDetail.vue'), hidden: true, meta: { title: '占位订单详情', activeMenu: '/orderListOccupancy', keepAlive: false } },
      { path: '/orderListDetailAppointment', name: 'orderListDetailAppointment', component: () => import('@/views/chargingOrder/orderListDetail.vue'), hidden: true, meta: { title: '预约订单详情', activeMenu: '/orderListAppointment', keepAlive: false } }
    ]
  },
  {
    path: '/invoice', component: Layout, name: 'invoice',
    meta: { title: '发票管理', icon: 'shebei', keepAlive: true },
    children: [
      { path: '/invoiceList', name: 'invoiceList', component: () => import('@/views/invoice/invoiceList'), meta: { title: '发票管理', keepAlive: true } },
      { path: '/invoiceDetail', name: 'invoiceDetail', component: () => import('@/views/invoice/invoiceDetail'), hidden: true, meta: { title: '发票详情' } },
      { path: '/invoiceConfig', name: 'invoiceConfig', component: () => import('@/views/invoice/invoiceConfig'), meta: { title: '发票配置' } }
    ]
  },
  {
    path: '/card', component: Layout, redirect: '/card/cardList',
    meta: { title: 'IC卡管理', icon: 'ic_Profiles', keepAlive: true },
    children: [
      { path: '/cardList', name: 'cardList', component: () => import('@/views/card/list'), meta: { title: 'IC卡管理', icon: 'ic_Profiles', keepAlive: true } },
      { path: '/useRecods', name: 'useRecods', component: () => import('@/views/card/useRecods'), meta: { title: '使用记录', activeMenu: '/cardList', keepAlive: true } },
      { path: '/rechargeRecords', name: 'rechargeRecords', component: () => import('@/views/card/rechargeRecords'), meta: { title: '充值记录', activeMenu: '/cardList', keepAlive: true } }
    ]
  },
  {
    path: '/rulesmanage', component: Layout, redirect: 'noRedirect', name: 'rulesmanage',
    children: [
      { path: '/rules', name: 'rulesList', component: () => import('@/views/rules'), meta: { title: '计费策略', icon: 'nested', keepAlive: true } }
    ]
  },
  {
    path: '/register', component: Layout, redirect: '/registerUser',
    meta: { title: '注册用户管理', icon: 'yonghu', keepAlive: true },
    children: [
      { path: '/registerUser', name: 'registerUser', component: () => import('@/views/registerUser/userList.vue'), meta: { title: '注册用户', icon: 'yonghu', keepAlive: true } },
      { path: '/userCar', name: 'userCar', component: () => import('@/views/userCar/userCarList.vue'), meta: { title: '车辆信息', icon: 'yonghu', keepAlive: true } },
      { path: '/chongzhiRecods', name: 'chongzhiRecods', component: () => import('@/views/registerUser/chongzhiRecods'), meta: { title: '充值记录', keepAlive: true } },
      { path: '/refund', name: 'refund', component: () => import('@/views/refund/refundList.vue'), meta: { title: '提现管理', keepAlive: true } }
    ]
  },
  {
    path: '/recharge', component: Layout, redirect: '/recharge',
    children: [
      { path: '/recharge', name: 'recharge', component: () => import('@/views/registerUser/recharge.vue'), meta: { title: '后台充值', icon: 'caiwu', keepAlive: true } }
    ]
  },
  {
    path: '/credit', component: Layout, redirect: '/creditList',
    meta: { title: '积分管理', icon: 'yonghu' },
    children: [
      { path: '/creditList', name: 'creditList', component: () => import('@/views/credit/creditList.vue'), meta: { title: '用户积分', keepAlive: true } },
      { path: '/creditDetail', name: 'creditDetail', component: () => import('@/views/credit/creditDetail.vue'), meta: { title: '积分明细', activeMenu: '/creditDetail', keepAlive: true } }
    ]
  },
  {
    path: '/operator', component: Layout, redirect: '/operatorList',
    meta: { title: '代理商管理', icon: 'daili', keepAlive: true },
    children: [
      { path: '/operatorList', name: 'operatorList', component: () => import('@/views/operator/operatorList'), meta: { title: '代理商', keepAlive: true } },
      { path: '/tixianRecods', name: 'tixianRecods', component: () => import('@/views/operator/tixianRecods'), hidden: true, meta: { title: '提现记录', keepAlive: false } },
      { path: '/childrenAccount', name: 'childrenAccount', component: () => import('@/views/operator/childrenAccount'), hidden: true, meta: { title: '代理商详情', keepAlive: false } },
      { path: '/operatorBalanceRecords', name: 'operatorBalanceRecords', component: () => import('@/views/operator/balanceRecords'), hidden: true, meta: { title: '代理商余额变更记录', keepAlive: false } }
    ]
  },
  {
    path: '/groupCharge', component: Layout, name: 'groupCharge', redirect: 'noRedirect',
    meta: { title: '团充管理', icon: 'shebei', keepAlive: true },
    children: [
      { path: '/groupList', name: 'groupList', component: () => import('@/views/groupCharge/groupList.vue'), meta: { title: '团体管理', keepAlive: true } },
      { path: '/userList', name: 'userList', component: () => import('@/views/groupCharge/userList'), meta: { title: '团充用户', keepAlive: true } },
      { path: '/groupOrderList', name: 'groupOrderList', component: () => import('@/views/groupCharge/groupOrderList'), meta: { title: '团充订单', keepAlive: true } },
      { path: '/groupRechargeList', name: 'groupRechargeList', component: () => import('@/views/groupCharge/groupRechargeList.vue'), meta: { title: '充值明细', keepAlive: true } },
      { path: '/groupCarVinList', name: 'groupCarVinList', component: () => import('@/views/groupCharge/groupCarVinList.vue'), meta: { title: 'VIN车辆', keepAlive: true } },
      { path: '/groupCarTeamList', name: 'groupCarTeamList', component: () => import('@/views/groupCharge/groupCarTeamList.vue'), meta: { title: '车队管理', keepAlive: true } },
      { path: '/teamAccount', name: 'teamAccount', component: () => import('@/views/groupCharge/components/TeamAccount.vue'), meta: { title: '余额流水', activeMenu: '/groupCarTeamList', keepAlive: false } },
      { path: '/companyBillList', name: 'companyBillList', component: () => import('@/views/groupCharge/companyBillList.vue'), meta: { title: '企业账单', keepAlive: true } },
      { path: '/groupConsumeList', name: 'groupConsumeList', component: () => import('@/views/groupCharge/groupConsumeList.vue'), meta: { title: '消费明细', keepAlive: true } },
      { path: '/virtualCardList', name: 'virtualCardList', component: () => import('@/views/groupCharge/virtualCardList.vue'), meta: { title: '虚拟电卡', keepAlive: true } },
      { path: '/virtualCardConsumeList', name: 'virtualCardConsumeList', component: () => import('@/views/groupCharge/virtualCardConsumeList.vue'), meta: { title: '虚拟电卡流水明细', keepAlive: true } }
    ]
  },
  {
    path: '/hlht', component: Layout, name: 'hlht', redirect: 'noRedirect',
    meta: { title: '第三方平台', icon: 'shebei', keepAlive: true },
    children: [
      { path: '/supOperatorList', name: 'supOperatorList', component: () => import('@/views/hlht/operatorList'), meta: { title: '运营商信息', keepAlive: true } },
      { path: '/platformList', name: 'platformList', component: () => import('@/views/hlht/thirdPlatformList.vue'), meta: { title: '平台信息', platformType: 'hlht', keepAlive: true } },
      { path: '/stationList', name: 'stationList', component: () => import('@/views/hlht/thirdStationList.vue'), meta: { title: '站点信息', platformType: 'hlht', keepAlive: true } },
      { path: '/equipmentList', name: 'equipmentList', component: () => import('@/views/hlht/equipmentList'), meta: { title: '设备信息', keepAlive: true } },
      { path: '/connectorList', name: 'connectorList', component: () => import('@/views/hlht/connectorList'), meta: { title: '接口信息', keepAlive: true } },
      { path: '/hlhtOrderList', name: 'hlhtOrderList', component: () => import('@/views/hlht/orderList'), meta: { title: '订单信息', keepAlive: true } }
    ]
  },
  {
    path: '/supervisePlatform', component: Layout, name: 'supervisePlatform', redirect: 'noRedirect',
    meta: { title: '监管平台', icon: 'shebei', keepAlive: true },
    children: [
      { path: '/supervisePlatformList', name: 'supervisePlatformList', component: () => import('@/views/hlht/supervisePlatformList.vue'), meta: { title: '平台信息', platformType: 'spt', keepAlive: true } },
      { path: '/superviseStationList', name: 'superviseStationList', component: () => import('@/views/hlht/superviseStationList.vue'), meta: { title: '站点信息', platformType: 'spt', keepAlive: true } }
    ]
  },
  {
    path: '/systemUser', component: Layout, name: 'systemUser', redirect: 'noRedirect',
    meta: { title: '系统管理', icon: 'nested', keepAlive: false },
    children: [
      { path: '/role', name: 'role', component: () => import('@/views/systemUser/roleList'), meta: { title: '岗位管理', keepAlive: false } },
      { path: '/user', name: 'user', component: () => import('@/views/systemUser/userList'), meta: { title: '用户管理', keepAlive: false } },
      { path: '/menu', name: 'menu', component: () => import('@/views/systemUser/menuList'), meta: { title: '菜单管理', keepAlive: false } },
      { path: '/log', name: 'log', component: () => import('@/views/systemUser/logList'), meta: { title: '操作日志', keepAlive: false } },
      { path: '/warning', name: 'warning', component: () => import('@/views/warning/warningList'), meta: { title: '告警列表', keepAlive: false } },
      { path: '/warningConfig', name: 'warningConfig', component: () => import('@/views/warning/warningConfig'), meta: { title: '设备告警配置', keepAlive: false } },
      { path: '/paramList', name: 'paramList', component: () => import('@/views/systemUser/paramList'), meta: { title: '参数设置', keepAlive: false } },
      { path: '/carInfo', name: 'carInfo', component: () => import('@/views/carInfo'), meta: { title: '车辆信息', icon: 'cheliang', keepAlive: false } }
    ]
  },
  {
    path: '/carManage', component: Layout, redirect: '/carManage',
    children: [
      { path: '/carManage', name: 'carManage', component: () => import('@/views/carManage'), meta: { title: '车辆管理', icon: 'cheliang', keepAlive: true } }
    ]
  },
  {
    path: '/feedback', component: Layout, redirect: '/feedbackList',
    children: [
      { path: '/feedbackList', name: 'feedbackList', component: () => import('@/views/feedback/feedbackList'), meta: { title: '反馈管理', icon: 'fankui', keepAlive: true } }
    ]
  },
  {
    path: '/advert', component: Layout, redirect: '/advertList',
    children: [
      { path: '/advertList', name: 'advertList', component: () => import('@/views/advert/advertList'), meta: { title: '广告管理', icon: 'guanggao', keepAlive: true } }
    ]
  },
  {
    path: '/promotion', component: Layout, redirect: '/promotionList',
    children: [
      { path: '/promotionList', name: 'promotionList', component: () => import('@/views/promotion/promotionList'), meta: { title: '促销管理', icon: 'cuxiao', keepAlive: true } }
    ]
  },
  {
    path: '/finance', component: Layout, name: 'finance', redirect: 'noRedirect',
    meta: { title: '财务管理', icon: 'caiwu', keepAlive: true },
    children: [
      { path: '/financeList', name: 'financeList', component: () => import('@/views/finance/financeList'), meta: { title: '财务管理', icon: 'caiwu', keepAlive: true } },
      { path: '/accountDetailsList', name: 'accountDetailsList', component: () => import('@/views/finance/accountDetailsList'), meta: { title: '分账明细列表', icon: 'caiwu', keepAlive: true } },
      { path: '/financeListForPlatform', name: 'financeListForPlatform', component: () => import('@/views/finance/financeListForPlatform'), meta: { title: '平台分账明细', icon: 'caiwu', keepAlive: false } },
      { path: '/financeListForOperator', name: 'financeListForOperator', component: () => import('@/views/finance/financeListForOperator'), meta: { title: '代理商分账明细', icon: 'caiwu', keepAlive: false } },
      { path: '/financeListForShareholder', name: 'financeListForShareholder', component: () => import('@/views/finance/financeListForShareholder'), meta: { title: '分成者分账明细', icon: 'caiwu', keepAlive: false } },
      { path: '/agentBill', name: 'agentBill', component: () => import('@/views/finance/agentBill'), meta: { title: '代理商对账', icon: 'caiwu', keepAlive: false } },
      { path: '/shareholderBill', name: 'shareholderBill', component: () => import('@/views/finance/shareholderBill'), meta: { title: '分成者对账', icon: 'caiwu', keepAlive: false } },
      { path: '/stationBill', name: 'stationBill', component: () => import('@/views/finance/stationBill'), meta: { title: '充电站对账', icon: 'caiwu', keepAlive: false } },
      { path: '/sortingPlatform', name: 'sortingPlatform', component: () => import('@/views/finance/sortingPlatform'), meta: { title: '清分账单汇总', icon: 'caiwu', keepAlive: false } },
      { path: '/sortingOperator', name: 'sortingOperator', component: () => import('@/views/finance/sortingOperator'), meta: { title: '清分明细代理商', icon: 'caiwu', keepAlive: false } },
      { path: '/sortingShareholder', name: 'sortingShareholder', component: () => import('@/views/finance/sortingShareholder'), meta: { title: '清分明细分成者', icon: 'caiwu', keepAlive: false } },
      { path: '/operatorMonth', name: 'operatorMonth', component: () => import('@/views/finance/operatorMonth'), meta: { title: '代理商月度对账单', icon: 'caiwu', keepAlive: false } },
      { path: '/stationMonth', name: 'stationMonth', component: () => import('@/views/finance/stationMonth'), meta: { title: '站点对账明细', icon: 'caiwu', keepAlive: false } },
      { path: '/operatorDay', name: 'operatorDay', component: () => import('@/views/finance/operatorDay'), meta: { title: '代理商日账单', icon: 'caiwu', keepAlive: false } },
      { path: '/accountdetail', name: 'accountdetail', component: () => import('@/views/finance/accountdetail'), meta: { title: '分账明细', keepAlive: false } },
      { path: '/sxfBalance', name: 'sxfBalance', component: () => import('@/views/finance/sxfBalance'), meta: { title: '随行付账户余额', icon: 'caiwu', keepAlive: false } }
    ]
  },
  {
    path: '/file', component: Layout, redirect: '/fileList',
    children: [
      { path: '/fileList', name: 'fileList', component: () => import('@/views/file/fileList'), meta: { title: '文件管理', icon: 'caiwu', keepAlive: true } }
    ]
  },
  {
    path: '/configList', component: Layout, redirect: '/configList',
    children: [
      { path: '/configList', name: 'configList', component: () => import('@/views/config/configList'), meta: { title: '网站配置', icon: 'caiwu', keepAlive: true } }
    ]
  },
  {
    path: '/newsList', component: Layout, redirect: '/newsList',
    children: [
      { path: '/newsList', name: 'newsList', component: () => import('@/views/news/newsList'), meta: { title: '文章管理', icon: 'caiwu', keepAlive: true } }
    ]
  },
  {
    path: '/marketing', component: Layout, name: 'marketing', redirect: 'noRedirect',
    meta: { title: '营销管理', icon: 'nested', keepAlive: true },
    // updated by lwk at 20260926
    children: [
      { path: '/serFeeDiscountList', name: 'serFeeDiscountList', component: () => import('@/views/discount/discountList'), meta: { title: '充值折扣列表', keepAlive: true } },
      { path: '/serFeeDiscountLogList', name: 'serFeeDiscountLogList', component: () => import('@/views/discount/discountLogList'), meta: { title: '充值折扣记录列表', keepAlive: true } },
      { path: '/editSerFeeDiscount', name: 'editSerFeeDiscount', component: () => import('@/views/discount/discountDetail'), meta: { title: '充值折扣配置', keepAlive: true } },
      { path: '/discountTemplate', name: 'discountTemplate', component: () => import('@/views/marketing/discountTemplateList'), meta: { title: '站点折扣模板', keepAlive: true } },
      { path: '/discountActivity', name: 'discountActivity', component: () => import('@/views/marketing/discountActivityList'), meta: { title: '站点折扣活动', keepAlive: false } },
      { path: '/couponActivity', name: 'couponActivity', component: () => import('@/views/marketing/couponActivityList'), meta: { title: '优惠券活动', keepAlive: true } },
      { path: '/couponTemplate', name: 'couponTemplate', component: () => import('@/views/marketing/couponTemplate'), meta: { title: '优惠券模板', keepAlive: true } },
      { path: '/couponInfo', name: 'couponInfo', component: () => import('@/views/marketing/couponInfoList'), meta: { title: '优惠券详情', keepAlive: true } },
      { path: '/timeBasedDiscount', name: 'timeBasedDiscount', component: () => import('@/views/marketing/timeBasedDiscountActivityList'), meta: { title: '分时折扣', keepAlive: true } },
      { path: '/blacklist', name: 'blacklist', component: () => import('@/views/marketing/userBlackList'), meta: { title: '黑名单', keepAlive: true }, hidden: true },
      { path: '/userGroup', name: 'userGroup', component: () => import('@/views/marketing/userGroup'), meta: { title: '用户组', keepAlive: true }, hidden: true },
      { path: '/activity', name: 'activity', component: () => import('@/views/marketing/countActivityDetail'), meta: { title: '新增活动', keepAlive: false }, hidden: true },
      { path: '/timeBasedDiscountActivity', name: 'timeBasedDiscountActivity', component: () => import('@/views/marketing/timeBasedDiscountActivityDetail'), meta: { title: '新增分时折扣活动', keepAlive: false }, hidden: true }
    ]
  },
  {
    path: '/accountChildren', component: Layout, redirect: '/accountChildren',
    children: [
      { path: '/accountChildren', name: 'accountChildren', component: () => import('@/views/accountChildren/index.vue'), meta: { title: '分成者管理', icon: 'caiwu', keepAlive: true } },
      { path: '/shareholderStationRatio', name: 'shareholderStationRatio', component: () => import('@/views/accountChildren/shareholderStationRatio.vue'), meta: { title: '分成比例设置', icon: 'caiwu', keepAlive: false } },
      { path: '/withdrawRecords', name: 'withdrawRecords', component: () => import('@/views/accountChildren/withdrawRecords.vue'), meta: { title: '分成者提现记录', icon: 'caiwu', keepAlive: true } },
      { path: '/suixinfuIncome', name: 'suixinfuIncome', component: () => import('@/views/operator/suixinfuIncome.vue'), meta: { title: '随行付进件', keepAlive: false }, hidden: true }
    ]
  },
  {
    path: '/sim', component: Layout, name: 'sim',
    meta: { title: '模拟充电桩', icon: 'shebei' },
    children: [
      { path: '/sim', name: 'simIndex', component: () => import('@/views/operator/index'), meta: { title: '模拟充电桩', keepAlive: true } }
    ]
  },
  {
    path: '/myaccount', component: Layout, redirect: '/myaccount',
    children: [
      { path: '/myaccount', name: 'myaccount', component: () => import('@/views/myaccount/index'), meta: { title: '我的账户', icon: 'zhanghu', keepAlive: true } }
    ]
  },
  {
    path: '/rechargeVehicle', name: 'RechargeVehicle', component: Layout, redirect: '/rechargeVehicle/list',
    children: [
      { path: '/list', name: 'RechargeVehicleList', component: () => import('@/views/rechargeVehicle/list'), meta: { title: '补电车管理', icon: 'rechargeVehicle', keepAlive: true } }
    ]
  },
  {
    path: '/:pathMatch(.*)*', redirect: '/', hidden: true
  }
];

const createRouterInstance = () =>
  createRouter({
    history: createWebHistory(),
    scrollBehavior: () => ({ top: 0 }),
    routes: constantRoutes
  });

const router = createRouterInstance();

// In Vue Router 4, to reset the router we replace the current routes
export function resetRouter() {
  const newRouter = createRouterInstance();
  // Remove all existing routes and add new ones
  router.getRoutes().forEach(route => {
    if (route.name) {
      router.removeRoute(route.name);
    }
  });
  newRouter.getRoutes().forEach(route => {
    router.addRoute(route);
  });
}

export default router;
